module.exports = __webpack_public_path__ + "img/service-bg.31fa63eb.png";